import { Dropdown_, Main_Plain, Table, TBody, TD, TH, THead, TR } from 'monica-alexandria'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StatisticsBreakdown = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height:100%;
`


const TableWrapper = styled.div`
  overflow-x: auto;
  padding: var(--normalPads);

;
`
const DropdownWrapper = styled.div`
  width: fit-content;
  padding-bottom: 1rem;
`
const StyledTable = styled(Table)`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  border: none;

  th, td {
    /* border: 1px solid ${(p)=>p.theme.color}; */
  }

;
`

const PaginationControls = styled.div`
  display: flex;
  /* grid-template-columns: 1fr 1fr 1fr; */
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;

  .disabledNav{
    opacity: 0.5;
    pointer-events: none;
  }

 
`;


const WidgetTitle = styled.h4`
  padding-bottom: 2rem;
`;

export default function Statistics_Breakdown(props) {

    const {t} = useTranslation();

    // const handleStreamChange= (value)=>{
    //     const streamValue = value === 'all' ? ['dailyprofit','lois','bond'] : [value]
    //     props.setStreams(streamValue)
    //     props.get_breakdown_view(streamValue)
    // }

    // const filteredKeys = props.keysStats?.filter(key => {
    //   const isQuestKey = key.value === 'activeQuests' || key.value === 'newActiveQuests';
    //   return props.streams.includes('dailyprofit') || !isQuestKey;
    // });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 11;

    const totalPages = Math.ceil((props.months?.length || 0) / itemsPerPage);

    const reversedMonths = [...(props.months || [])].reverse();

    const paginatedMonths = reversedMonths.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

    useEffect(() => {
      setCurrentPage(1);
    }, [props.months]);
    
    console.log('stream', props.streams)
    
  return (
    <StatisticsBreakdown>
        {/* <DropdownWrapper>
        <Dropdown_ label={t('Stream')} >
            <select
                value={props.streams}
                onChange={(e)=> handleStreamChange(e.target.value)}
            >
              <option value='all'>{t('All streams')}</option>
              <option value='dailyprofit'>Questad</option>
              <option value='lois' >Adsnap</option>
              <option value='bond'>Pocket agency </option>
            </select>
        </Dropdown_>
        </DropdownWrapper> */}

        <TableWrapper>
                              <WidgetTitle>{t('Statistics breakdown')}</WidgetTitle>
          
            <StyledTable>
            <THead>
                <TR>
                <TH>{t('Month')}</TH>
                    {props.keysStats?.map((key) => (
                      <TH key={key?.value}>{key.text}</TH>
                    ))}
                </TR>
            </THead>
            <TBody>
              {paginatedMonths?.map((month) => (
                <TR key={month}>
                    <TD>{month}</TD>
                    {props.keysStats?.map((key) => (
                        <TD key={key?.value}><span>{props.kpiData[month][key?.value]}</span></TD>
                    ))}
                </TR>
                ))}
            </TBody>
            </StyledTable>
          
        </TableWrapper>
        <PaginationControls>
            <Main_Plain  className={currentPage === 1 ? 'disabledNav': null} onClick={() => setCurrentPage(p => p - 1)} text= {t('Previous')} size='small' iconLeft='Back'  />

            <p>{t('Page')} {currentPage} / {totalPages}</p>

            <Main_Plain size='small' className={currentPage === totalPages ? 'disabledNav': null} onClick={() => setCurrentPage(p => p + 1)} text= {t('Next')} iconRight='Next'/>   
        </PaginationControls>
    </StatisticsBreakdown>
  )
}
